import { Icon, IconType, IconSize, Header2Text, SmallBodyText } from 'ui-toolkit';
import * as React from 'react';
import styled from 'styled-components';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

const StyledDocumentModalTitle = styled.div`
  display: grid;
  grid-template: auto / min-content 1fr;
`;

const StyledTextContent = styled.div`
  align-content: space-between;
  display: grid;
  grid-template-rows: min-content min-content;
`;

const StyledFilename = styled(SmallBodyText)`
  color: ${(props) => props.theme.colors.darkGray};
`;

interface IDocumentModalTitle {
  superText: string;
}

export const DocumentModalTitle: FCWithChildren<IDocumentModalTitle> = ({ children, superText }) => (
  <StyledDocumentModalTitle>
    <Icon type={IconType.Upload} size={IconSize.Large} />
    <StyledTextContent>
      <StyledFilename>{superText}</StyledFilename>
      <Header2Text>{children}</Header2Text>
    </StyledTextContent>
  </StyledDocumentModalTitle>
);
